import { z } from "zod";

export const checkoutContactEmailSchema = z
  .preprocess(
    (value) => (typeof value === "string" ? value : ""),
    z
      .string()
      .trim()
      .min(1, "Enter your email address.")
      .max(254, "Email address cannot be longer than 254 characters.")
      .email("Enter a valid email address."),
  )
  .transform((email) => email.toLowerCase());
